import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initBrandAssets } from './utils/brandAssets';

initBrandAssets();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
